import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandEntityFileUploadPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandEntityFileUploadProperties = {
    [name in keyof EntityCommandEntityFileUploadPropertyValues]: Property<EntityCommandEntityFileUploadPropertyValues[name]>
};

export interface IEntityCommandEntityFileUpload extends IEntityCommand, EntityCommandEntityFileUploadProperties
{
}

export class EntityCommandEntityFileUpload extends EntityCommand implements IEntityCommandEntityFileUpload
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandEntityFileUpload";
    public static override className = "EntityCommandEntityFileUpload";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandEntityFileUploadPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Upload",
                entityName: "EntityFile",
                key: "UPLOAD",
                permission: PermissionEvaluator.permissionLevels.create,
                type: EntityCommandTypeEnum.entitySet,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandEntityFileUploadPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        caller = entityCommandInformation.caller.get();

                    if (!caller || !caller.openUploadEntityFileDialogAsync)
                        return;

                    return caller.openUploadEntityFileDialogAsync();
                })
        );
    }

    // #endregion

    // #endregion
}

